import { ProductApi } from '../../../api/Product'
import Product from '../../../components/Main/Product/Product'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import useSubmit from '../../../elements/Hooks/useSubmit'
import { message } from 'antd'
import { isEmpty, pick } from 'lodash'
import DocumentsApi from '../../../api/Documents'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

const docsApi = new DocumentsApi()

function ProductCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => ProductApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  const {
    visible,
    modalType,
    object: product,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    setObject: setProduct,
  } = useModalData(ProductApi.create, ProductApi.update, ProductApi.remove, fetch)
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('products', product.status),
    [product.status],
    isEmpty(product.status)
  )
  const [submittingOperation, submitOperation] = useSubmit(ProductApi.operation)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    const productDB = await submitOperation(operation, pick(product, ['_key', '_rev', '_id']))
    if (operation === 'duplicate' && productDB) onCancel(true)

    if (productDB) setProduct(productDB)

    hide()
  }
  const isNew = modalType === 'new'
  const isRemovable = !['Confirmed', 'Revised'].includes(product.status)
  const isUpdatable = !isEmpty(actions.filter((a) => a.key === 'update')) || isNew

  return (
    <Product
      {...{
        list,
        fetching,
        submitting,
        visible,
        fetch,
        product,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        actions,
        fetchingActions,
        fetchActions,
        handleActions,
        company,
        onChangeCompany,
        isUpdatable,
        isNew,
        isRemovable,
      }}
    />
  )
}

export default ProductCont
